import { Loader2, Mail } from 'lucide-react'
import { Button } from '@/modules/shared/components/ui/button'
import {
	Form,
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@/modules/shared/components/ui/form'
import { Input } from '@/modules/shared/components/ui/input'
import { AuthLayoutComponent } from '../components/auth-layout.component'
import { useAuthForgetPassword } from '../hooks/use-auth-forget-password.hook'

export function AuthForgetPasswordPage() {
	const { form, isLoading, error, submitAuthForgetPassword } = useAuthForgetPassword()

	return (
		<AuthLayoutComponent
			titleAuth="Esqueci minha senha"
			navigation="Voltar ao login"
			route="/login"
		>
			<Form {...form}>
				<form
					onSubmit={form.handleSubmit(submitAuthForgetPassword)}
					className="space-y-4"
				>
					<div className="text-center mb-6">
						<Mail className="mx-auto h-12 w-12 text-gray-400 mb-4" />
						<p className="text-gray-600">
							Digite seu e-mail e enviaremos um link para redefinir sua senha
						</p>
					</div>

					<FormField
						control={form.control}
						name="email"
						render={({ field }) => (
							<FormItem>
								<FormLabel>E-mail</FormLabel>
								<FormControl>
									<Input
										type="email"
										placeholder="Digite seu e-mail"
										{...field}
									/>
								</FormControl>
								<FormMessage />
							</FormItem>
						)}
					/>

					{error && (
						<div className="text-sm text-red-600">
							Erro ao enviar e-mail. Verifique se o e-mail está correto.
						</div>
					)}

					<Button
						className="mt-6 w-full"
						type="submit"
						disabled={isLoading}
					>
						{isLoading && <Loader2 size={20} className="mr-2 animate-spin" />}
						Enviar link de recuperação
					</Button>

					<div className="text-center text-sm text-gray-500 mt-4">
						Lembre-se de verificar sua caixa de spam
					</div>
				</form>
			</Form>
		</AuthLayoutComponent>
	)
}